import GenericErrorComponent from './GenericErrorComponent';

export default GenericErrorComponent;